import React from 'react';
import { TranslationFunction } from 'react-i18next';

import { Footer } from '../Footer';
import { Header } from '../Header';
import { Filter, FilterProps, FilterType } from '../Filter';
import { RevisionList, RevisionListProps } from '../RevisionList';

import { ComposerHeader } from 'wix-style-react';

import styles from './Sidebar.scss';

export interface SidebarProps {
  t: TranslationFunction;
  revisionList: any;
  filterOption: FilterType;
  supportLink: string;
  activeRevision: string;
  currentRevision: string;
  hasReleaseCandidate: boolean;
  isSeparateRevisions: boolean;
  isBackToDashboard: boolean;
  onBackToDashboard(): void;
  onView: RevisionListProps['onView'];
  onRestore: RevisionListProps['onRestore'];
  onStar: RevisionListProps['onStar'];
  onRename: RevisionListProps['onRename'];
  onFilterChange: FilterProps['onChange'];
}

export const Sidebar: React.FC<SidebarProps> = ({
  t,
  revisionList,
  activeRevision,
  currentRevision,
  hasReleaseCandidate,
  isSeparateRevisions,
  isBackToDashboard,
  onBackToDashboard,
  onFilterChange,
  onView,
  onRestore,
  onRename,
  onStar,
  supportLink,
}) => {
  return (
    <div className={styles.sidebar} data-hook="history-sidebar">
      {isBackToDashboard && (
        <ComposerHeader
          backButtonValue={t('BACK_TO_DASHBOARD')}
          onBackClick={onBackToDashboard}
        />
      )}
      <Header t={t} supportLink={supportLink} />
      <Filter
        t={t}
        onChange={onFilterChange}
        hasReleaseCandidate={hasReleaseCandidate}
      />
      <RevisionList
        t={t}
        isSeparateRevisions={isSeparateRevisions}
        activeRevision={activeRevision}
        currentRevision={currentRevision}
        revisions={revisionList}
        onView={onView}
        onRestore={onRestore}
        onStar={onStar}
        onRename={onRename}
      />
      <Footer t={t} />
    </div>
  );
};
